import Main from '@/pages/framework/main.vue'

let routes = [{
	path: '/',
	component: Main,
	// redirect: '/welcome',
	children: [{
		path: 'welcome',
		meta: {
			auth: true,
			code: 'SYS_WELCOME'
		},
		component: resolve => require(['@/pages/system/welcome/'], resolve),
		name: '欢迎页'
	}, {
		path: 'factory',
		meta: {
			auth: true,
			code: 'SP_FACTORY'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/factory/'], resolve),
		name: '工厂管理'
	}, {
		path: 'merchandiser',
		meta: {
			auth: true,
			code: 'SP_MERCHANDISER'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/merchandiser/'], resolve),
		name: '跟单员维护'
	}, {
		path: 'user',
		meta: {
			auth: true,
			code: 'SYS_USER'
		},
		component: resolve => require(['@/pages/system/user/list.vue'], resolve),
		name: '用户'
	}, {
		path: 'user/add',
		meta: {
			auth: true,
			code: 'SYS_USER_ADD'
		},
		component: resolve => require(['@/pages/system/user/edit.vue'], resolve),
		name: '添加用户'
	}, {
		path: 'user/edit',
		meta: {
			auth: true,
			code: 'SYS_USER_EDIT'
		},
		component: resolve => require(['@/pages/system/user/edit.vue'], resolve),
		name: '编辑用户'
	}, {
		path: 'department',
		meta: {
			auth: true,
			code: 'SYS_DEPARTMENT'
		},
		component: resolve => require(['@/pages/system/department/'], resolve),
		name: '部门管理'
	}, {
		path: 'post',
		meta: {
			auth: true,
			code: 'SYS_POST'
		},
		component: resolve => require(['@/pages/system/post/'], resolve),
		name: '岗位管理'
	}, {
		path: 'role',
		meta: {
			auth: true,
			code: 'SYS_ROLE'
		},
		component: resolve => require(['@/pages/system/role/'], resolve),
		name: '角色管理'
	}, {
		path: 'datadict',
		meta: {
			auth: true,
			code: 'SYS_DATADICT'
		},
		component: resolve => require(['@/pages/system/datadict/'], resolve),
		name: '数据字典'
	}, {
		path: 'boxmai',
		meta: {
			auth: true,
			code: 'SP_BOXMAI'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/boxmai/list.vue'], resolve),
		name: 'Macys箱嘪维护'
	}, {
		path: 'boxmai/new',
		meta: {
			auth: true,
			code: 'SP_BOXMAI_NEW'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/boxmai/edit.vue'], resolve),
		name: 'Macys箱嘪新增'
	}, {
		path: 'boxmai/edit',
		meta: {
			auth: true,
			code: 'SP_BOXMAI_EDIT'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/boxmai/edit.vue'], resolve),
		name: 'Macys箱嘪编辑'
	}, {
		path: 'boxmai/import/pa',
		meta: {
			auth: true,
			code: 'SP_BOXMAI_IMPORT_PA'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/boxmai/import-pa.vue'], resolve),
		name: 'Macys导入PA'
	}, {
		path: 'boxmai/import/mc',
		meta: {
			auth: true,
			code: 'SP_BOXMAI_IMPORT_MC'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/boxmai/import-mc.vue'], resolve),
		name: 'Macys导入MC'
	}, {
		path: 'styleImage',
		meta: {
			auth: true,
			code: 'SP_STYLEIMAGE'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/styleimg/'], resolve),
		name: 'Macys款式图'
	}, {
		path: 'fine',
		meta: {
			auth: true,
			code: 'SP_FINE'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/fine/'], resolve),
		name: 'Macys罚款登记'
	}, {
		path: 'report/boxmai',
		meta: {
			auth: true,
			code: 'SP_REPORT_BOXMAI'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/report/boxmai/'], resolve),
		name: 'Macys箱嘪报表'
	}, {
		path: 'report/contract',
		meta: {
			auth: true,
			code: 'SP_REPORT_CONTRACT'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/report/contract/'], resolve),
		name: 'Macys合同登记报表'
	}, {
		path: 'report/season',
		meta: {
			auth: true,
			code: 'SP_REPORT_SEASON'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/report/season/'], resolve),
		name: 'Macys季度统计报表'
	}, {
		path: 'report/prod',
		meta: {
			auth: true,
			code: 'SP_REPORT_PROD'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/report/prod/'], resolve),
		name: 'Macys生产进度统计报表'
	}, {
		path: 'report/pack',
		meta: {
			auth: true,
			code: 'SP_REPORT_PACK'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/report/pack/'], resolve),
		name: 'Macys装箱单统计报表'
	}, {
		path: 'macys/qc',
		meta: {
			auth: true,
			code: 'Macys_QC'
		},
		component: resolve => require(['@/pages/macys/qc/list.vue'], resolve),
		name: 'Macys查货报告'
	}, {
		path: 'brand',
		meta: {
			auth: true,
			code: 'SP_BRAND'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/brand/list.vue'], resolve),
		name: 'Macys品牌管理'
	}, {
		path: 'brand/config',
		meta: {
			auth: true,
			code: 'SP_BRAND_CONFIG'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/brand/brandconfig.vue'], resolve),
		name: 'Macys品牌配置'
	}, {
		path: 'brand/prepack',
		meta: {
			auth: true,
			code: 'SP_BRAND_PREPACK'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/brand/brandprepack.vue'], resolve),
		name: 'Macys品牌尺码'
	}, {
		path: 'brand/prepack/list',
		meta: {
			auth: true,
			code: 'SP_BRAND_PREPACK_LIST'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/brand/prepack-list.vue'], resolve),
		name: 'Macys品牌尺码类型'
	}, {
		path: 'indcdate',
		meta: {
			auth: true,
			code: 'SP_INDCDATE'
		},
		component: resolve => require(['@/pages/boxmai/boxmai/indcdate/'], resolve),
		name: 'Macys船期维护'
	}, {
		path: 'fa/boxmai',
		meta: {
			auth: true,
			code: 'FA_BOXMAI'
		},
		component: resolve => require(['@/pages/fa/boxmai/list.vue'], resolve),
		name: 'FA箱嘪管理'
	}, {
		path: 'fa/boxmai/import/pa',
		meta: {
			auth: true,
			code: 'FA_BOXMAI_IMPORT_PA'
		},
		component: resolve => require(['@/pages/fa/boxmai/import.vue'], resolve),
		name: 'FA箱嘪PA导入'
	}, {
		path: 'fa/stylefact',
		meta: {
			auth: true,
			code: 'FA_STYLEFACT'
		},
		component: resolve => require(['@/pages/fa/stylefact/list.vue'], resolve),
		name: 'FA款号工厂管理'
	}, {
		path: 'fa/report/boxmai',
		meta: {
			auth: true,
			code: 'FA_REPORT_BOXMAI'
		},
		component: resolve => require(['@/pages/fa/report/boxmai/index.vue'], resolve),
		name: 'FA箱嘪报表'
	}, {
		path: 'fa/report/customer',
		meta: {
			auth: true,
			code: 'FA_REPORT_CUSTOMER'
		},
		component: resolve => require(['@/pages/fa/report/customer/index.vue'], resolve),
		name: 'FA客户报表'
	}, {
		path: 'fa/qc',
		meta: {
			auth: true,
			code: 'FA_QC'
		},
		component: resolve => require(['@/pages/fa/qc/list.vue'], resolve),
		name: 'FA查货报告'
	}, {
		path: 'aero/boxmai',
		meta: {
			auth: true,
			code: 'AERO_BOXMAI'
		},
		component: resolve => require(['@/pages/aero/boxmai/list.vue'], resolve),
		name: 'AERO箱嘪管理'
	}, {
		path: 'aero/schedule',
		meta: {
			auth: true,
			code: 'AERO_SCHEDULE'
		},
		component: resolve => require(['@/pages/aero/schedule/index.vue'], resolve),
		name: 'AERO排期表管理'
	}, {
		path: 'aero/report/boxmai',
		meta: {
			auth: true,
			code: 'AERO_REPORT_BOXMAI'
		},
		component: resolve => require(['@/pages/aero/report/boxmai/index.vue'], resolve),
		name: 'AERO箱嘪报表'
	}, {
		path: 'aero/report/pack',
		meta: {
			auth: true,
			code: 'AERO_REPORT_PACK'
		},
		component: resolve => require(['@/pages/aero/report/pack/index.vue'], resolve),
		name: 'AERO装箱单'
	}, {
		path: 'aero/report/customer',
		meta: {
			auth: true,
			code: 'AERO_REPORT_CUSTOMER'
		},
		component: resolve => require(['@/pages/aero/report/customer/list.vue'], resolve),
		name: 'AERO系数表'
	}, {
		path: 'aero/indcdate',
		meta: {
			auth: true,
			code: 'AERO_INDCDATE'
		},
		component: resolve => require(['@/pages/aero/indcdate/index.vue'], resolve),
		name: 'AERO船期维护'
	}, {
		path: 'aero/country',
		meta: {
			auth: true,
			code: 'AERO_COUNTRY'
		},
		component: resolve => require(['@/pages/aero/country/list.vue'], resolve),
		name: 'AERO国家维护'
	}, {
		path: 'aero/qc',
		meta: {
			auth: true,
			code: 'AERO_QC'
		},
		component: resolve => require(['@/pages/aero/qc/index.vue'], resolve),
		name: 'AERO查货报告'
	}, {
		path: 'macy/materialDb',
		meta: {
			auth: true,
			code: 'MACY_MATERIALDB'
		},
		component: resolve => require(['@/pages/macys/db/materialDb/index.vue'], resolve),
		name: '面料资料库维护'
	},
	{
		path: 'macy/subMaterialDb',
		meta: {
			auth: true,
			code: 'MACY_SUBMATERIALDB'
		},
		component: resolve => require(['@/pages/macys/db/subMaterialDb/index.vue'], resolve),
		name: '辅料资料库维护'
	},{
		path: 'bill',
		meta: {
			auth: true,
			code: 'MACY_BILL'
		},
		component: resolve => require(['@/pages/bill/bill/list.vue'], resolve),
		name: '报关单'
	},{
		path: 'bill/import',
		meta: {
			auth: true,
			code: 'MACY_BILL_IMPORT'
		},
		component: resolve => require(['@/pages/bill/bill/import.vue'], resolve),
		name: '报关单导入'
	},{
		path: 'colorcarddb',
		meta: {
			auth: true,
			code: 'DATABASE_COLORCARDDB'
		},
		component: resolve => require(['@/pages/macys/db/colorcarddb/list.vue'], resolve),
		name: '色卡资料库'
	},{
		path: 'artcarddb',
		meta: {
			auth: true,
			code: 'DATABASE_ARTCARDDB'
		},
		component: resolve => require(['@/pages/macys/db/artcarddb/list.vue'], resolve),
		name: 'Artcard文件维护'
	},{
		path: 'mca',
		meta: {
			auth: true,
			code: 'ORDERTRACK_MAC'
		},
		component: resolve => require(['@/pages/ordertrack/mca/list.vue'], resolve),
		name: 'MCA跟进'
	},{
		path: 'handscraping',
		meta: {
			auth: true,
			code: 'ORDERTRACK_HANDSCRAPING'
		},
		component: resolve => require(['@/pages/ordertrack/handscraping/list.vue'], resolve),
		name: '手刮样跟进'
	},{
		path: 'handscraping/new',
		meta: {
			auth: true,
			code: 'ORDERTRACK_HANDSCRAPING_NEW'
		},
		component: resolve => require(['@/pages/ordertrack/handscraping/edit.vue'], resolve),
		name: '手刮样新增'
	},{
		path: 'handscraping/edit',
		meta: {
			auth: true,
			code: 'ORDERTRACK_HANDSCRAPING_EDIT'
		},
		component: resolve => require(['@/pages/ordertrack/handscraping/edit.vue'], resolve),
		name: '手刮样编辑'
	},{
		path: 'handscraping/comment',
		meta: {
			auth: true,
			code: 'ORDERTRACK_HANDSCRAPING_COMMENT'
		},
		component: resolve => require(['@/pages/ordertrack/handscraping/comment.vue'], resolve),
		name: '手刮样评论'
	},{
		path: 'sample',
		meta: {
			auth: true,
			code: 'ORDERTRACK_SAMPLE'
		},
		component: resolve => require(['@/pages/ordertrack/sample/list.vue'], resolve),
		name: '样办跟进'
	}]
}];

export default routes;


// WEBPACK FOOTER //
// ./src/config/routes/framework.js